


































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import { CONFIG } from '@/config';
import { Http } from '@/decorators';
import { ApprovalHierarchyType, SalesChannel } from '@/modules/direct-sales/enums';
import { Size } from '@/enums';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { notificationService } from '@/services';
import { DAP_ROUTES } from '@/modules/dap/router';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { AxiosError, AxiosResponse } from 'axios';
import { httpService } from '@/services';

declare const $: any;

@Component({
  subscriptions() {
    return {
      calcTotais: this.$watchAsObservable('dataForecast').pipe(
        pluck('newValue'),
        debounceTime(400),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    ActionBar,
    PageLoader
  }
})
export default class DirectSalesDistributionByDealerPage extends Vue {
  @Prop({ required: true })
  public projectId: number;

  @Prop({ required: true })
  public storeId: number;
  public moment = moment;

  public goBack() {
    this.$router.push({
      name: DAP_ROUTES.SUBMITTED_PROJECTS_RETAIL
    });
  }

  public state: any = {
    data: [],
    dataAlter: [],
    dap: [],
    entries: [],
    selectedHierarchy: 0,
    dataForecast: [],
    datahistoric: [],
    dataForecastdebundled: [],
    objectSub: [],
    approvalHierarchyRetail: 0,
    idApprovalFlowEvent: 0,
    idDealer: 0,
    description: ''
  };

  public dataForecast: any[] = [];
  public dataForecastOriginal: any[] = [];

  public Size = Size;
  public phasesFlow: string[] = ['DAP'];
  public years: string[] = [];
  public yearsHistoric: string[] = [];
  public calcTotais: any[];
  public minYear: any = '';
  public minYearComplete: any = '';

  public async mounted() {
    this.getForecast();
  }

  @Http(
    'get',
    ({ projectId, storeId }) =>
      `${CONFIG.URL.NEODASH_API}/api/dap/approval/${projectId}/rap/retail/response/${storeId}`
  )
  public async getForecast(params?: any, error?, data?) {
    if (error) {
      return;
    }

    this.phasesFlow = ['DAP'];

    this.state.approvalHierarchyRetail = _(data)
      .filter((f: any) => f.permitAlter == true)
      .map((m: any) => m.approvalHierarchyRetail)
      .value()[0];

    this.state.idApprovalFlowEvent = _(data)
      .filter((f: any) => f.permitAlter == true)
      .map((m: any) => m.idApprovalFlowEvent)
      .value()[0];

    this.state.idDealer = _(data)
      .filter((f: any) => f.permitAlter == true)
      .map((m: any) => m.idDealer)
      .value()[0];

    this.state.description = _(data)
      .filter((f: any) => f.permitAlter == true)
      .map((m: any) => m.description)
      .value()[0];

    this.state.data = data;

    this.state.dap = data.filter(function(f) {
      return f.approvalHierarchyRetail == 0;
    });

    this.state.dataAlter = data.filter(function(f) {
      return f.approvalHierarchyRetail > 0 && f.approvalHierarchyRetail;
    });

    this.phasesFlow = this.phasesFlow.concat(
      this.state.dataAlter.map(function(f) {
        return f.approvalHierarchyName;
      })
    );

    this.years = _.orderBy(
      _.uniq(
        this.state.dataAlter[0].forecast_RapFamilyResultsPerMonth.map((m: any) => m.year.toLocaleString().substr(3))
      )
    );
    this.yearsHistoric = _.orderBy(
      _.uniq(
        this.state.dataAlter[0].consolidate_RapFamilyResultsPerMonth.map((m: any) => m.year.toLocaleString().substr(3))
      )
    );

    this.minYear = _.min(this.years);
    this.minYearComplete = _.min(
      _.orderBy(_.uniq(this.state.dataAlter[0].forecast_RapFamilyResultsPerMonth.map((m: any) => m.year)))
    );

    let historic = this.calcHistoric();

    this.state.dataForecastdebundled = this.generateForecast(this.state.dataAlter, this.state.dap);
    let historicAndForecasts = historic.concat(this.state.dataForecastdebundled);
    this.dataForecast = this.orderByGroupForecast(historicAndForecasts);
    this.dataForecastOriginal = _.flattenDeep(this.dataForecast)
      .filter(f => f.permitAlter === true)
      .map(i => ({
        idEntity: i.idEntity,
        value: i.value
      }));
  }

  public updateModels() {
    var req: any = [];

    let original = this.dataForecastOriginal;

    this.state.objectSub = _.flatten(
      this.dataForecast.map((m: any) =>
        _.filter(
          m,
          item =>
            item.permitAlter === true &&
            original.some(function(f) {
              return f.idEntity == item.idEntity && f.value != item.value;
            })
        )
      )
    );

    if (
      this.state.description !=
      _(this.state.data)
        .filter((f: any) => f.permitAlter == true)
        .map((m: any) => m.description)
        .value()[0]
    ) {
      var obj = {
        IdProject: this.projectId,
        IdStoreProject: this.state.idDealer,
        HierachyRetail: this.state.approvalHierarchyRetail,
        IdApprovalFlowEvent: this.state.idApprovalFlowEvent,
        Description: this.state.description
      };

      req.push(
        httpService.http.put(
          `${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.projectId}/rap/response/description/${this.storeId}/${
            this.state.approvalHierarchyRetail
          }`,
          obj
        )
      );
    }

    if (this.state.objectSub.length > 0) {
      let hierarchyId = this.state.objectSub[0].approvalHierarchyRetail;

      req.push(
        httpService.http.put(
          `${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.projectId}/rap/response/${this.storeId}/${hierarchyId}`,
          this.state.objectSub
        )
      );
    }

    if (req.length == 0) return;

    Promise.all(req)
      .then(() => {
        notificationService.sendToast({
          status: 1,
          type: 'success',
          message: 'Registros alterados com sucesso!'
        });
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public get getTotal() {
    return this.calcTotais
      ? this.calcTotais.reduce(function(acumulador, valorAtual, indice) {
          valorAtual.forEach(function(a, v) {
            if (indice == 0) {
              acumulador.push({
                approvalHierarchyRetail: a.approvalHierarchyRetail,
                familyName: 'Total',
                idFamily: 0,
                order: a.order,
                permitAlter: false,
                value: a.value,
                year: a.year
              });
            } else {
              acumulador[v].value =
                (acumulador[v].value ? parseInt(acumulador[v].value) : 0) + (a.value ? parseInt(a.value) : 0);
            }
          });
          return acumulador;
        }, [])
      : [];
  }

  public formatNumber(v: any) {
    return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  public get permitAlter() {
    return this.state.dataForecastdebundled.some(
      (s: any) =>
        s.permitAlter === true && (!s.finishedIn && s.approvalHierarchyRetail === this.state.approvalHierarchyRetail)
    );
  }

  public calcHistoric() {
    let historicRes = this.generateHitoricResult(this.state.dap[0].consolidate_RapFamilyResultsPerMonth);

    let HistoricForecast = this.generateHitoricForecast(this.state.dap[0].forecast_RapFamilyResultsPerMonth);

    let HistoricTotal = HistoricForecast.map((m: any) => {
      return {
        approvalHierarchyRetail: m.approvalHierarchyRetail,
        permitAlter: false,
        familyName: m.familyName,
        finishedIn: m.finishedIn,
        idFamily: m.idFamily,
        border: true,
        value:
          m.value +
          historicRes.filter(
            (f: any) =>
              f.year === m.year && f.idFamily === m.idFamily && f.approvalHierarchyRetail === m.approvalHierarchyRetail
          )[0].value,
        year: m.year,
        order: 2
      };
    });

    historicRes = historicRes.concat(HistoricForecast).concat(HistoricTotal);

    return historicRes;
  }

  public generateHitoricResult(consolidate_RapFamily: any) {
    return consolidate_RapFamily.map((m: any) => {
      return { ...m, approvalHierarchyRetail: this.state.dap[0].approvalHierarchyRetail, permitAlter: false, order: 0 };
    });
  }

  public generateHitoricForecast(consolidate_RapFamily: any) {
    return consolidate_RapFamily
      .filter((f: any) => this.yearsHistoric.some((s: any) => s == f.year.toLocaleString().substr(3)))
      .map((m: any) => {
        return {
          ...m,
          approvalHierarchyRetail: this.state.dap[0].approvalHierarchyRetail,
          permitAlter: false,
          order: 1
        };
      });
  }

  public generateForecast(data: any, data2: any) {
    var dataForecast = _.concat(
      data.map((m: any) =>
        m.forecast_RapFamilyResultsPerMonth
          .filter((f: any) => this.years.some((s: any) => s == f.year.toLocaleString().substr(3)))
          .map((f: any) => {
            return {
              ...f,
              finishedIn: f.finishedIn,
              approvalHierarchyRetail: m.approvalHierarchyRetail,
              permitAlter: m.permitAlter
            };
          })
      )
    );

    var dataForecast2 = _.concat(
      data2.map((m: any) =>
        m.forecast_RapFamilyResultsPerMonth
          .filter((f: any) => this.years.some((s: any) => s == f.year.toLocaleString().substr(3)))
          .map((f: any) => {
            return { ...f, approvalHierarchyRetail: m.approvalHierarchyRetail, permitAlter: false };
          })
      )
    );

    return _.flatten([...dataForecast, ...dataForecast2]);
  }

  public orderByGroupForecast(data: any) {
    return _(data)
      .orderBy((forecast: any) => forecast.year)
      .orderBy((forecast: any) => forecast.familyName)
      .orderBy((forecast: any) => forecast.order)
      .orderBy((forecast: any) => forecast.approvalHierarchyRetail)
      .groupBy((forecast: any) => forecast.familyName)
      .map((forecast: any[], name: string) => {
        return forecast;
      })
      .value();
  }

  public confirmFinal() {
    $(this.$refs.promptDialog)
      .modal({
        closable: false,
        onApprove: () => {
          $('#file-upload-widget').trigger('click');
        }
      })
      .modal('show');
  }

  public updateModelsFinalize() {
    let original = this.dataForecastOriginal;

    this.state.objectSub = _.flatten(
      this.dataForecast.map((m: any) =>
        _.filter(
          m,
          item =>
            item.permitAlter === true &&
            original.some(function(f) {
              return f.idEntity == item.idEntity && f.value != item.value;
            })
        )
      )
    );

    var obj = {
      IdProject: this.projectId,
      IdStoreProject: this.state.idDealer,
      HierachyRetail: this.state.approvalHierarchyRetail,
      Dtos: this.state.objectSub,
      IdApprovalFlowEvent: this.state.idApprovalFlowEvent,
      Description: this.state.description
    };

    const req = [
      httpService.http.put(
        `${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.projectId}/rap/response/finalize/${this.storeId}/${
          this.state.approvalHierarchyRetail
        }`,
        obj
      )
    ];

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        this.getForecast();
        notificationService.sendToast({
          status: 1,
          type: 'success',
          message: 'Projeto finalizado com sucesso!'
        });
      })
      .catch((err: AxiosError) => console.log(err.message));
  }
}
